import React from 'react';
import '../../../components/layout/ModuleLayout.css';
import IssueTriageTab from '../../../components/capa/IssueTriageTab';
import InvestigationsTab from '../../../components/capa/InvestigationsTab';
import RemediationsTab from '../../../components/capa/RemediationsTab';
import FeedbackTab from '../../../components/capa/FeedbackTab';
import InsightsTab from '../../../components/capa/InsightsTab';
import ArchivedTab from '../../../components/capa/ArchivedTab';
import { CapaTabKey } from './CapaTabs';

interface CapaNetBodyProps {
  activeTab?: CapaTabKey;
}

const CapaNetBody: React.FC<CapaNetBodyProps> = ({ activeTab = 'insights' }) => {
  const renderPanel = () => {
    if (activeTab === 'issue-triage')   return <IssueTriageTab />;
    if (activeTab === 'investigations') return <InvestigationsTab />;
    if (activeTab === 'remediations')   return <RemediationsTab />;
    if (activeTab === 'feedback')       return <FeedbackTab />;
    if (activeTab === 'insights')       return <InsightsTab />;
    if (activeTab === 'archived')       return <ArchivedTab />;
    return (
      <div className="coming-soon">
        <span className="soon-badge">Coming soon</span>
        <p>This tab is under construction.</p>
      </div>
    );
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default CapaNetBody;
